<template>
<div class="page">
    <div class="form">
        <div class="item">
            <label>原手机号</label>
            <div class="input">
                <input type="text" v-model="form.old_mobile" readonly placeholder="未设置">
            </div>
        </div>
        <div class="item">
            <label>新手机号</label>
            <div class="input">
                <input type="text" v-model="form.mobile" placeholder="请输入">
            </div>
        </div>
        <div class="item">
            <label>验证码</label>
            <div class="input">
                <input type="text" v-model="form.code" placeholder="请输入">
            </div>
            <div class="code" @click="getSmsCode">{{code_btn_text}}</div>
        </div>
        <div class="item-tips">
            <div class="td-fcc">
                <img :src="Images.icon_stress" />
                <span>新手机号要在正常使用状态</span>
            </div>
            <div class="td-fcc">
                <span>建议您保留好您的手机号，确保账号安全</span>
            </div>
        </div>
        <div class="btn-box td-f">
            <Btn class="btn td-f1 td-fcc" loading @confirmEvent="submitForm">确定</Btn>
        </div>
    </div>
</div>
</template>

<script>
import Lockr from 'lockr'
import { mapGetters } from "vuex";
import Header from '@/components/Header'
import {
    QiniuUpload
} from '@/utils/qiniuUpload'
export default {
    components: {
        'Header': Header,
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    data() {
        return {
            timer: null,
            countDown: 60,
            is_wait: false,
            code_btn_text: "获取验证码",
            form: {
                old_mobile: '',
                mobile: '',
                code: ''
            }
        };
    },
    mounted() {
        console.log('this.userInfo.mobile---->', this.userInfo.mobile);
        if(!this.userInfo.mobile) {
            this.$router.replace('bindMobile?type=no_mobile');
        } else {
            this.form.old_mobile = this.userInfo.mobile;
        }
    },
    methods: {
        // 获取短信验证码
        async getSmsCode() {
            if (this.is_wait) return;
            let {
                mobile
            } = this.form;
            if (!mobile) {
                this.Message({
                    title: "请输入新手机号",
                });
                return;
            }
            // if (!this.$checkPhone(mobile)) {
            //     this.Message({
            //         title: "新手机号输入有误，请重新输入",
            //     });
            //     return;
            // }
            this.is_wait = true
            let url = this.API.smsCode;
            let params = {
                mobile: mobile,
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    title: "短信发送成功，请注意查收！",
                    onClose: () => {
                        this.coolDownSmsCode()
                    }
                });
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 获取短信验证码冷却
        coolDownSmsCode() {
            this.code_btn_text = `${this.countDown}秒后重试`
            this.timer = setInterval(() => {
                this.countDown--
                if (this.countDown < 0) {
                    this.code_btn_text = '获取验证码'
                    this.timer && clearInterval(this.timer)
                    this.countDown = 60
                    this.is_wait = false
                } else {
                    this.code_btn_text = `${this.countDown}秒后重试`
                }
            }, 1000)
        },
        // 提交表单
        async submitForm(done) {
            let {
                old_mobile,
                mobile,
                code
            } = this.form;
            if (!old_mobile) {
                this.Message({
                    title: "请输入原手机号",
                });
                return done();
            }
            // if (!this.$checkPhone(old_mobile)) {
            //     this.Message({
            //         title: "原手机号输入有误，请重新输入",
            //     });
            //     return done();
            // }
            if (!mobile) {
                this.Message({
                    title: "请输入新手机号",
                });
                return done();
            }
            // if (!this.$checkPhone(mobile)) {
            //     this.Message({
            //         title: "新手机号输入有误，请重新输入",
            //     });
            //     return done();
            // }
            if (!code) {
                this.Message({
                    title: "请输入验证码",
                });
                return done();
            }
            let url = this.API.change_mobile;
            let params = {
                old_mobile: old_mobile,
                mobile: mobile,
                sms_code: code,
                token: this.Lockr.get('token')
            };
            let result = await this.$post(url, params);
            done();
            this.timer && clearInterval(this.timer);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.$store.dispatch("UserInfo", true);
                this.Message({
                    title: "手机号修改成功",
                    onClose: () => {
                        this.$router.go(-1);
                    }
                });
                setTimeout(() => {}, 1000);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        }
    },
};
</script>

<style lang="less" scoped>
.form {
    padding: 10px 15px;

    .item {
        padding: 0 10px;
        height: 50px;
        border-radius: 5px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;

        label {
            margin-right: 10px;
            font-size: 15px;
            color: #333;
            flex-shrink: 0;
        }

        .input {
            flex: 1;
            height: 50px;
        }

        input {
            width: 100%;
            line-height: 50px;
            font-size: 14px;
            color: #333;
            text-align: right;
        }

        .code {
            min-width: 80px;
            text-align: center;
            font-size: 14px;
            color: #7181eb;
            flex-shrink: 0;
            line-height: 14px;
            padding-left: 10px;
            margin-left: 10px;
            border-left: solid #7181eb 1px;
        }
    }

    .item-tips {
        display: flex;
        flex-direction: column;
        padding-top: 15px;

        img {
            width: 14px;
            height: 14px;
            display: block;
            margin-right: 5px;
        }

        span {
            font-size: 12px;
            color: #999;
            line-height: 2;
        }
    }

    .btn {
        height: 40px;
        background: linear-gradient(225deg, #9cb2f4, #6472e8);
        border-radius: 3px;
        font-size: 15px;
        color: #fff;
        text-align: center;
        margin-top: 40px;
    }
}
</style>
